import { useEffect, useState } from "react";
import ComponentCard from "../../../components/common/ComponentCard";
import Button from "../../../components/ui/button/Button";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Form from "../../../components/form/Form";
import Select from "../../../components/form/Select";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function AddNewInspectionItem() {
  const token = localStorage.getItem("token");
  const [headings, setHeadings] = useState<any[]>([]);

  const fetchHeadings = async () => {
    try {
      const response = await fetch(`${apiUrl}/inspection_items/headings`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
      });
      const result = await response.json();
      
      if (result.success) {
        setHeadings(result.headings);
      }
    } catch (err) {
      console.error("Error fetching headings:", err);
      setHeadings([]);
    }
  };
  
  useEffect(() => {
    fetchHeadings();
  }, []);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    inspectionitemname: "",
    headingid: "",
    status: "",
    details: "",
  });

  const [errors, setErrors] = useState({
    inspectionitemname: "",
    headingname: "",
    status: "",
    details: "",
  });

  //Handle text input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  // ✅ Handle select dropdowns
  const handleSelectStatus = (option:any) => {
    
    setFormData({
      ...formData,
      status: option,
      
    });
    setErrors({
      ...errors,
      status: "",
    });
  };

  const handleSelectHeading = (option: any) => {
    setFormData({
      ...formData,
      headingid: option,
    });
    setErrors({
      ...errors,
      headingname: "",
    });
  };

  //Handle submit
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // if (!validate()) return;
    console.log("Form Data to submit:", formData);

    try {
      const token = localStorage.getItem("token");
      const payload = {
        inspectionitemname: formData.inspectionitemname,
        headingid: formData.headingid,
        status: formData.status,
        details: formData.details,
      };
      const response = await fetch(`${apiUrl}/inspection_items`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        navigate("/inspection-items");
      } else {
        console.error("Failed to add record:", await response.text());
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const handleCancel = () => {
    navigate("/inspection-items");
  };

  return (
    <ComponentCard title="Add New Inspection Item">
      <Form onSubmit={handleSubmit}>
        <div className="grid gap-6">
          <div className="col-span-full">
            <h4 className="pb-4 text-base font-medium text-gray-800 border-b border-gray-200 dark:border-gray-800 dark:text-white/90">
              Inspection Item Details
            </h4>
          </div>

          {/* Inspection Item Name */}
          <div>
            <Label>Inspection Item Name</Label>
            <Input
              type="text"
              name="inspectionitemname"
              value={formData.inspectionitemname}
              onChange={handleChange}
            />
            {errors.inspectionitemname && (
              <p className="text-red-500 text-sm">{errors.inspectionitemname}</p>
            )}
          </div>

          {/* Heading */}
          <div>
            <Label>Heading</Label>
            <Select
              options={headings.map(heading => ({
                key: heading.inspectiontaskheading_id,       
                value: heading.inspectiontaskheading_id,      
                label: heading.name,
              }))}
              onChange={handleSelectHeading}
              className="mt-2 bg-gray-50 dark:bg-gray-800"
            />
            {errors.headingname && (
              <p className="text-red-500 text-sm">{errors.headingname}</p>
            )}
          </div>

          {/* Status */}
          <div>
            <Label>Status</Label>
            <Select
              options={[
                {value: "Current", label: "Current" },
                {value: "Non-Current", label: "Non-Current" },

              ]}
              onChange={handleSelectStatus}
              className="mt-2 bg-gray-50 dark:bg-gray-800"
            />
            {errors.status && (
              <p className="text-red-500 text-sm">{errors.status}</p>
            )}
          </div>

          {/* Details */}
          <div>
            <Label>Details</Label>
            <textarea
              className="w-full rounded-lg border px-4 py-2.5 text-sm shadow-theme-xs focus:outline-none text-gray-600 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800"
              name="details"
              onChange={handleChange}
              value={formData.details}
            />
            {errors.details && (
              <p className="text-red-500 text-sm">{errors.details}</p>
            )}
          </div>

          {/* Buttons */}
          <div className="flex gap-3">
            <Button size="sm" type="submit">
              Save Changes
            </Button>
            <Button size="sm" variant="outline" type="button" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </Form>
    </ComponentCard>
  );
}
